import axios from "axios";

// URL
const BASE_URL = "https://portalsales.tuku.coffee/api";
const AUTH_LOGIN = "/auth/login";
const AUTH_VALIDATE_OTP = "/auth/validateOTP";
const AUTH_RESEND_OTP = "/auth/resendOTP";
// const AUTH_REGISTER = "/auth/register"

// user constant variable
const verified_user = "verified_user"
const unverified_user = "unverified_user"

// const register = (username, password) => {
//   return axios.post(API_URL + "register", {
//     username,
//     password,
//   });
// };

// const login = async (username, password) => {
//   const response = await axios
//         .post(API_URL + "login", {
//             username,
//             password,
//         });
//     if (response.data.username === username) {
//         localStorage.setItem("user", JSON.stringify(response.data));
//     }
//   const responseBranch = await axios.get(API_URL+"api/dataCore/getBranchIdView")

//   localStorage.setItem("branch", JSON.stringify(responseBranch.data.data))
//   const getBranch =  JSON.parse(localStorage.getItem("branch"))

//   let dataOptionsBranch = [{ label: 'all', value: 'all' }]
//   for (var i = 0; i < getBranch.length; i++) {
//     console.log("data", dataOptionsBranch)
//     dataOptionsBranch.push({ label: getBranch[i], value: getBranch[i] })
//   }
//   localStorage.setItem("optionsBranch", JSON.stringify(dataOptionsBranch))
//   return response.data;
// };

// login service
const login = async (loginData) => {
  try {
   // console.log("loginData", loginData)
    const response = await axios.post(BASE_URL + AUTH_LOGIN  , loginData);
    // console.log("response", response.data)
    localStorage.setItem(unverified_user, JSON.stringify(response.data));
    return response.data;
  } catch (error) {
    throw error;
  }
};

// validate otp service
const validateOTP = async (otpData) => {
  try {
    // get user data from local storage
    const user = JSON.parse(localStorage.getItem(unverified_user));
    // update email otpData
    otpData.email = user.email;
    // send otpData to server
    const response = await axios.post(BASE_URL + AUTH_VALIDATE_OTP, otpData);
   // console.log("response", response.data)

    // remove unverified_user from local storage
    localStorage.removeItem(unverified_user);

    // set verified_user in local storage
    if (response.data.email === otpData.email) {
      localStorage.setItem(verified_user, JSON.stringify(response.data));
    }

    // return response data
    return response.data;
  } catch (error) {
    throw error;
  }
};

// resend otp service
const resendOTP = async () => {
  try {
    // get user data from local storage
    const user = JSON.parse(localStorage.getItem(unverified_user));
    // get email from user
    const email = user.email;
    // send email to server
    const response = await axios.post(BASE_URL + AUTH_RESEND_OTP, { email });
    // remove unverified_user from local storage
    localStorage.removeItem(unverified_user);
    // set unverified_user in local storage
    localStorage.setItem(unverified_user, JSON.stringify(response.data));
   // console.log("response resend otp", response.data)
    return response.data;
  } catch (error) {
    throw error;
  }
};

// logout service
const logout = async () => {
  // if unvirified_user exist remove it
  if (localStorage.getItem(unverified_user)) {
    localStorage.removeItem(unverified_user);
  }
  return localStorage.removeItem(verified_user);
};

// get user ip address
const getIPAddress = async () => {
  try {
    const response = await axios.get('https://api.ipify.org?format=json');
    return response.data.ip;
  } catch (error) {
    console.error('Error fetching IP:', error);
    throw new Error('Failed to fetch IP address');
  }
};



const AuthService = {
  // register,
  login,
  logout,
  getIPAddress,
  validateOTP,
  resendOTP,
  verified_user,
  unverified_user,
}

export default AuthService;
